import http from '../http/http';

import {
    EPC_LOOKUP_BY_PROPERTY,
    generateEndpoint,
    ONE_PROPERTY_EPC,
    PROPERTY_EPCS,
} from '../http/endpoints';

export default (() => {
    const update = (id, params) =>
        http.put(generateEndpoint(ONE_PROPERTY_EPC, { id }), params);

    const create = (params) =>
        http.post(generateEndpoint(PROPERTY_EPCS), params);

    const remove = (id) =>
        http.delete(generateEndpoint(ONE_PROPERTY_EPC, { id }));

    const lookupEpcByProperty = (id) =>
        http.get(generateEndpoint(EPC_LOOKUP_BY_PROPERTY, { id }));

    return {
        lookupEpcByProperty,
        create,
        update,
        remove,
    };
})();
